import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { CONDITION_SET_ACTION_TYPE } from 'store/underwriting/actions';

const initialState = {};

const conditionSetsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CONDITION_SET_ACTION_TYPE.GET_CONDITION_SETS:
        return payload || state;

      case CONDITION_SET_ACTION_TYPE.ADD_CONDITION_SET:
        draft[payload.id] = payload;
        break;

      case CONDITION_SET_ACTION_TYPE.UPDATE_CONDITION_SET:
        draft[payload.id] = { ...payload, links: state[payload.id].links };
        break;

      case CONDITION_SET_ACTION_TYPE.DELETE_CONDITION_SET:
        delete draft[payload];
        break;

      case CONDITION_SET_ACTION_TYPE.ADD_CONDITION_TO_SET:
        draft[payload.conditionSetId].links.push(payload);
        break;

      case CONDITION_SET_ACTION_TYPE.DELETE_CONDITION_FROM_SET:
        draft[payload.conditionSetId].links = state[payload.conditionSetId].links.filter(
          ({ id }) => id !== payload.conditionConditionSetId,
        );
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default conditionSetsReducer;
